const EU_TAX_REGEX = new RegExp("^[A-Z]{2}[0-9]{8,}$");
const HU_TAX_REGEX = /(\d{8}\-[1-5]\-(?:0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51)){1}$/;

function toggleSideCartTaxValidator() {
  document.querySelector("#popup-tax-validator").classList.toggle("show");
  document.querySelector(".previewCart-wrapper .previewCart").classList.toggle("active-tool");
  document.querySelector(".previewCart__tax-validator--errors").style.display = "none";
  document.querySelector("#tax-validator-checkbox").checked = true;
}

function withoutTaxNumberSelected() {
  if (document.querySelector(".previewCart__tax-validator--error-not-selected"))
    document.querySelector(".previewCart__tax-validator--error-not-selected").style.display = "none";
  updateTaxNumber("", "", "");
  document.querySelector(".previewCart__tax-validator--fields").classList.remove("previewCart__tax-validator--fields-shown");
  enableSideCartTaxButton();
}

function withTaxNumberSelected() {
  if (document.querySelector(".previewCart__tax-validator--error-not-selected"))
    document.querySelector(".previewCart__tax-validator--error-not-selected").style.display = "none";
  document.querySelector(".previewCart__tax-validator--fields").classList.add("previewCart__tax-validator--fields-shown");
  enableSideCartTaxButton();
}

function enableSideCartTaxButton() {
  let blockedButton = document.querySelector("#popup-tax-validator .button");
  if (blockedButton) {
    blockedButton.removeAttribute("disabled");
  }
}

function validateTaxNumberOnSideCart() {
  if (document.querySelector("#with-tax-number").checked == true) {
    let enteredCompanyName = document.querySelector("#tax-validator-company-name").value;
    let enteredTaxnumber = document.querySelector("#tax-validator-company-number").value;
    let isEu = document.querySelector("#eu-tax").checked;
    if (enteredCompanyName == "" || !validateTaxNumber(enteredTaxnumber, isEu)) {
      document.querySelector(".previewCart__tax-validator--errors").style.display = "block";
      return;
    }
    updateTaxNumber(enteredTaxnumber, enteredCompanyName, isEu); 
  }
  toggleSideCartTaxValidator();
  document.querySelector("[tax-validator-disabled]").removeAttribute("tax-validator-disabled");
}

function validateTaxNumber(text, isEU) {
  if (isEU == true)
    return EU_TAX_REGEX.test(text);
  else
    return text.match(HU_TAX_REGEX);
}

function cartTaxNumberCheckboxClick() {
  if (document.querySelector("#tax-validator-checkbox").checked == true) {
    updateTaxNumber("");
    document.querySelector(".cart__tax-validator--input").setAttribute("disabled", "");
  } else {
    document.querySelector(".cart__tax-validator--input").removeAttribute("disabled");
  }
}

function updateTaxNumber(taxNumber, companyName, isEU) {
    let shippingItemVariants = JSON.stringify({
        "attributes": {
            "tax-number": taxNumber,
            "company-name": companyName,
            "is-eu": isEU
          }
        });
    fetch('/cart/update.js', {method: "POST", body: shippingItemVariants, headers: { "Content-type": "application/json"}});
}